import { PAGE_ROUTES } from '@/components/nav/utils/url-builders';
import useHubs from '@/hooks/use-hubs';
import { useNavigate } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import {
  HeaderRowWithCustomIcon,
  HeaderRowWithHubSVG,
} from './header-row-with-svg';
import HeaderWithSidebarToggle from './header-with-sidebar-toggle';

type HubListHeaderComponents = {
  subRow?: ReactNode;
  findInViewFilter?: ReactNode;
};

export const HubListHeader = ({
  subRow,
  findInViewFilter,
}: HubListHeaderComponents) => {
  const { hubPathIdentifier } = useHubs();
  return (
    <div className="sticky top-0 z-20">
      <div className="flex flex-row justify-between text-md px-8 py-2 items-center border-b h-10">
        <HeaderWithSidebarToggle>
          <HeaderRowWithHubSVG
            hubPathIdentifier={hubPathIdentifier as string}
          />
        </HeaderWithSidebarToggle>
        {findInViewFilter}
      </div>
      {subRow && (
        <div className="flex flex-row justify-between px-6 text-md items-center border-b">
          {subRow}
        </div>
      )}
    </div>
  );
};

type HubDealPageHeaderComponents = {
  separator?: ReactNode;
  shortIdWrapper?: ReactNode;
  rowLeft?: ReactNode;
  rowRight?: ReactNode;
  isArchived?: boolean;
};

export const HubDealPageHeader = ({
  separator,
  shortIdWrapper,
  rowLeft,
  rowRight,
  isArchived = false,
}: HubDealPageHeaderComponents) => {
  const navigate = useNavigate();
  const { hubPathIdentifier } = useHubs();
  return (
    <div className="flex w-full h-10 shrink-0 items-center justify-between px-8 py-2 dark:bg-dark">
      <div className="flex flex-row items-center gap-3">
        <div className="flex flex-row items-center">
          <HeaderWithSidebarToggle>
            <div
              className="cursor-pointer"
              onClick={() => {
                navigate({
                  to: `/${hubPathIdentifier}/${isArchived ? PAGE_ROUTES.ARCHIVED_DEALS : PAGE_ROUTES.DEALS}`,
                });
              }}
            >
              <HeaderRowWithHubSVG hubPathIdentifier={hubPathIdentifier} />
            </div>
          </HeaderWithSidebarToggle>
          {separator}
          {shortIdWrapper}
        </div>
        {rowLeft}
      </div>
      {rowRight}
    </div>
  );
};

type GenericHeaderProps = {
  icon: React.ReactNode;
  copy: string;
};

export const GenericHeader = ({ icon, copy }: GenericHeaderProps) => {
  return (
    <div className="sticky top-0 z-20 bg-dashboard-background">
      <div className="flex flex-row justify-between text-md px-8 py-2 items-center border-b h-10">
        <HeaderWithSidebarToggle>
          <HeaderRowWithCustomIcon icon={icon} copy={copy} />
        </HeaderWithSidebarToggle>
      </div>
    </div>
  );
};
